import { Response } from "./handleResponse";
import { azureTokenInfo } from "../utils/azureTokenInfo";
import { itgExecution } from "./itgExecution";
import { queryParam } from "./queryParam";
import { templateFlowEngine } from "../constants/elements";

const templateString = templateFlowEngine.innerHTML;
const cimaVaild = sessionStorage.getItem("cimaValid");
export const cimaRedirectTransform = async (): Promise<Response> =>
  itgExecution.transform(
    {
      headers: {
        AuthType: "AzureAD",
        Authorization: `Bearer ${(await azureTokenInfo).access_token}`,
      },
      query: {
        ...queryParam,
        ...(cimaVaild &&
          JSON.parse(cimaVaild) && {
            displayFormReferenceKey: localStorage.getItem("displayFormReferenceKey"),
            sessionId: localStorage.getItem("sessionId"),
            stepId: localStorage.getItem("stepId"),
            submitButton: localStorage.getItem("submitButton"),
          }),
        retainState: true,
      },
    },
    templateString,
    true
  );
